import React from 'react';
import { ButtonGroup, Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { Action, AnotherAction, PrimaryButton, RoundedDropdown, SeparatedLink, SomethingElseHere } from '../../../../Constant';
import CommonDropDown from '../Common/CommonDropDown';
import { RoundedData } from '../../../../Data/Ui-kit/Data';
import HeaderCard from '../../../Common/HeaderCard';
import { Btn } from '../../../../AbstractElements';

const Rounded = () => {
  return (
    <Col sn='12' xl='12'>
      <Card>
        <HeaderCard title={RoundedDropdown} />
        <CardBody className='dropdown-basic'>
          <ButtonGroup>
            <Dropdown>
              <Btn color='primary dropbtn btn-round d-flex gap-2'>
                {PrimaryButton}
                <span>
                  <i className='icofont icofont-arrow-down'></i>
                </span>
              </Btn>
              <DropdownMenu className='dropdown-content'>
                <DropdownItem href='#'>{Action}</DropdownItem>
                <DropdownItem href='#'>{AnotherAction}</DropdownItem>
                <DropdownItem href='#'>{SomethingElseHere}</DropdownItem>
                <DropdownItem href='#'>{SeparatedLink}</DropdownItem>
              </DropdownMenu>
            </Dropdown>{' '}
          </ButtonGroup>
          {RoundedData.map((items) => (
            <CommonDropDown key={items.id} item={items} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Rounded;
